import { render, staticRenderFns } from "./supplier-statement.vue?vue&type=template&id=84ed895a&scoped=true"
import script from "./supplier-statement.vue?vue&type=script&lang=js"
export * from "./supplier-statement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84ed895a",
  null
  
)

export default component.exports